import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=87873910&scoped=true"
import script from "./Palette.vue?vue&type=script&lang=ts"
export * from "./Palette.vue?vue&type=script&lang=ts"
import style0 from "./Palette.vue?vue&type=style&index=0&id=87873910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87873910",
  null
  
)

export default component.exports